import React from "react";
import type { IListingHighlight } from "@/src/shared/types/listing";

/** The app's highlights: icon, title and a line of description; no heading. */
const ListingHighlights: React.FC<{ highlights: IListingHighlight[] }> = ({
  highlights,
}) => (
  <ul className="flex flex-col gap-4">
    {highlights.map((highlight) => (
      <li key={highlight.id} className="flex items-start gap-3">
        {highlight.icon && (
          <img
            src={highlight.icon}
            alt=""
            className="mt-0.5 h-6 w-6 shrink-0 object-contain"
          />
        )}
        <div>
          <p className="text-base font-medium text-ink">{highlight.title}</p>
          {highlight.description && (
            <p className="mt-0.5 text-sm font-medium text-ink-secondary">
              {highlight.description}
            </p>
          )}
        </div>
      </li>
    ))}
  </ul>
);

export default ListingHighlights;
